import { render, staticRenderFns } from "./Stages.vue?vue&type=template&id=5bb6f006&scoped=true"
import script from "./Stages.vue?vue&type=script&lang=js"
export * from "./Stages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6f006",
  null
  
)

export default component.exports